import { Component, EventEmitter, Input, OnInit, Output, ViewChild, ElementRef } from '@angular/core';
import { OtpFacade } from '@domain/application/facade/otp/otp.facade';
import { SessionService } from '@domain/application/observable-services/session.service';
import { DestinationCustomerRequest } from '@utils/classes/request/destination-customer-request';
import { DestinationRequest } from '@utils/classes/request/destination-request';
import { EmailRequest } from '@utils/classes/request/email-request';
import { IdentityDocumentRequest } from '@utils/classes/request/identity-document-request';
import { OtpCustomerRequest } from '@utils/classes/request/otp-customer-request';
import { OtpMailRequest } from '@utils/classes/request/otp-mail-request';
import { OtpRequest } from '@utils/classes/request/otp-request';
import { IStep } from '../../utils/interfaces/step.interface';
import { ControlContainer, FormGroupDirective } from '@angular/forms';
import { getEmailOtpFormInstance } from '@modules/business-accounts/forms/utils/otp/builders/otp-builder.class';
import { CustomersFacade } from '@domain/application/facade';
import { CustomerReniecResponse, IOtpMailResponse } from '@utils/interfaces/response';
import { VisitEvent } from '@modules/business-accounts/utils/classes/visit-event.class';
import { TraceEventName } from '@modules/business-accounts/utils/enums/trace-events.enum';
import { TraceService } from '@modules/business-accounts/services/trace/trace.service';
import { TraceError } from '@modules/business-accounts/utils/enums/trace-erros.enum';
import { RouterService } from '@modules/business-accounts/core/router/router.service';
import { BARoutes } from '@utils/constants/routes/cmp-link';

@Component({
  selector: 'ba-get-code-otp-step',
  templateUrl: './get-code-otp-step.component.html',
  styleUrls: ['./get-code-otp-step.component.scss'],
  viewProviders: [
    {
      provide: ControlContainer,
      useExisting: FormGroupDirective,
    },
  ],
})
export class GetCodeOtpStepComponent extends BARoutes() implements OnInit, IStep<string> {
  @Input() isClient: boolean = false;
  @Output() stepDone = new EventEmitter<string>();

  emails: string[] = [];
  showValidation: boolean = false;

  isLoading = false;
  firstName: string = '';
  isFlowActive: boolean = false;
  @ViewChild('inputEmail') inputEmail!: ElementRef;

  constructor(
    private readonly sessionService: SessionService,
    private readonly otpFacade: OtpFacade,
    private readonly controlContainer: ControlContainer,
    private readonly customersFacade: CustomersFacade,
    private readonly traceService: TraceService,
    public readonly viewRouter: RouterService
  ) {
    super();
  }

  ngOnInit(): void {
    const { documentNumber } = this.sessionService.getCommonInfoValue;
    this.fetchReniecData(documentNumber);
    this.traceService.registerEvent(new VisitEvent(TraceEventName.PAGE_RENDER_OTP_GET_CODE));
  }

  validationCodeOtpStep() {
    this.traceService.registerEvent(new VisitEvent(TraceEventName.ACTION_OTP_GET_CODE));
    this.isLoading = true;
    const { firstName, lastName, documentNumber } = this.sessionService.getCommonInfoValue;

    let emailRequest: EmailRequest[] = [
      {
        id: '1',
        type: 'PERSONAL',
        value: this.form.get('emailOtp')?.get('email')?.value.toString(),
      },
    ];

    let identityDocumentRequest: IdentityDocumentRequest[] = [
      {
        type: 'DNI',
        number: documentNumber,
      },
    ];

    let customerRequest: OtpCustomerRequest = new OtpCustomerRequest();
    customerRequest.firstName = firstName;
    customerRequest.email = emailRequest;
    customerRequest.identityDocument = identityDocumentRequest;

    let destinationCustomerRequest: DestinationCustomerRequest = new DestinationCustomerRequest();
    destinationCustomerRequest.firstName = `${firstName} ${lastName}`;

    let destinationRequest: DestinationRequest = new DestinationRequest();
    destinationRequest.customer = destinationCustomerRequest;

    let otpRequest: OtpRequest = new OtpRequest();
    otpRequest.type = 'OTP_SXF';
    otpRequest.channel = 'EMAIL';
    otpRequest.operationType = 'UNCATEGORIZED_ADMIN';
    otpRequest.identifierType = 'IDENTITY_DOCUMENT';
    otpRequest.customer = customerRequest;
    otpRequest.destination = destinationRequest;

    let otpMailRequest: OtpMailRequest = new OtpMailRequest(otpRequest);
    this.otpFacade.otpMail(otpMailRequest).subscribe({
      next: (response: IOtpMailResponse) => {
        this.sessionService.setCommonInfo = { otpMailRequest: otpMailRequest, signatureId: response.signatureId };
        this.isLoading = false;
        this.stepDone.emit(this.form.get('emailOtp')?.get('email')?.value.toString());
      },
      error: (error) => {
        this.isLoading = false;
        this.traceService.registerError(TraceError.OTP_EMAIL_ERROR, error);
        console.log(error);
      },
    });
  }

  fetchReniecData(documentNumber: string) {
    this.customersFacade
      .fetchReniecData(documentNumber)
      .pipe()
      .subscribe({
        next: ({ customer }: CustomerReniecResponse) => {
          this.sessionService.setCommonInfo = { customer: customer };
          this.sessionService.setCommonInfo = {
            firstName: customer.firstName,
            lastName: customer.lastName,
          };
          this.firstName = customer.firstName + ',';
          if (this.isClient) {
            this.emails = customer.email?.map((item) => item.value) || [];
            if (!this.emails.length) {
              this.showValidation = true;
              this.traceService.registerError(TraceError.OTP_NO_EMAIL_ERROR);
            } else this.form?.get('emailOtp')?.get('email')?.setValue(this.emails[0]);
          } else {
            const { email } = this.sessionService.getCommonInfoValue;
            this.emails.push(email);
            this.form?.get('emailOtp')?.get('email')?.setValue(email);
          }
          this.changeStyleInputEmail();
        }, error: (err: any) => console.log(err)
      });
  }

  toggleFlowVisibility(isVisible: boolean, btn?: any) {
    this.isFlowActive = isVisible;
    if (btn != undefined) btn.preventDefault();
  }

  changeStyleInputEmail() {
    setTimeout(() => {
      const label = this.inputEmail.nativeElement.children[0] as HTMLLabelElement;
      label.style.width = '100%';
      const span = label.children[2] as HTMLSpanElement;
      span.style.float = 'right';
      span.style.position = 'inherit';
    }, 100);
  }

  lastStep() {
    this.sessionService.setCommonInfo = { lastStep: true };
    const { documentNumber } = this.sessionService.getCommonInfoValue;
    if (documentNumber.length == 8)
      this.viewRouter.navigate(this.baRoutes.STARTUP);
    else
      this.viewRouter.navigate(this.baRoutes.BUSINESS_DATA);
  }

  get form() {
    return (this.controlContainer as FormGroupDirective).form;
  }

  get emailOtpForm() {
    return getEmailOtpFormInstance({ from: this.form });
  }

  getTextCapitalize(text: string) {
    let value = text.charAt(0).toUpperCase() + text.substring(1).toLowerCase();
    return value;
  }
}
